import React, { useEffect, useState } from "react";
import rwandaLogo from "../../assets/rwanda-logo.png";
import moment from "moment";
import LetterTemplateHeader from "../LetterTemplateHeader";
import LetterTemplateFooter from "../LetterTemplateFooter";
import rejectedImg from "../../assets/rejected.jpg";
import cancelledImg from "../../assets/cancelled.jpg";
import { connect } from "react-redux";
import {
  getSelectedPlanningEntity,
  selectPlanningEntity,
} from "../../../store/rbm/actions";
import { getEntitySectorPlanningEntities } from "../../../store/structure/actions";

const CustomizedLetter = (props) => {
  const {
    enableToFillLetter = false,
    docLetterNo = "",
    signContent = "",
    subTitle = "",
    recipientContent,
    entitySectorId,
    letterBodyContentInput = "",
    letterBodyContent = "",
    title = "",
    copiedInstitutionContentInput = "",
    copiedInstitutionContent = "",
    titleInput = "",
    ccSelectForm = "",
    loadFooterContent,
    disableToEditLetterHeader,
    rejected,
    cancelled,
    titlePosition = "left",
    planningEntityId,
    planningEntities,
    selectedPlanningEntityId,
    getEntitySectorPlanningEntities,
    getSelectedPlanningEntity,
    onDownload,
  } = props;

  const [letterCustomization, setLetterCustomization] = useState(null);

  const loadHeaderContent = (data) => {
    setLetterCustomization(data);
  };

  useEffect(() => {
    if (!planningEntities?.length) {
      getEntitySectorPlanningEntities((status) => {
        // console.log(status);
      });
    }
  }, []);

  useEffect(() => {
    if (!selectedPlanningEntityId) {
      getSelectedPlanningEntity();
    }
  }, [selectedPlanningEntityId, planningEntities]);

  return (
    <>
      <div className="letterMainContent">
        <div className="letter2">
          <div
            style={{
              paddingLeft: "20px",
              paddingRight: "20px",

              backgroundImage: !!cancelled
                ? `url('${cancelledImg}')`
                : !!rejected
                ? `url('${rejectedImg}')`
                : "none",
              backgroundSize: "cover",
              backgroundPosition: "center",
              backgroundRepeat: "no-repeat",
              opacity: 0.8, // Adjust transparency if needed
            }}
          >
            <LetterTemplateHeader
              disableToEdit={disableToEditLetterHeader}
              entitySectorId={entitySectorId}
              planningEntityId={planningEntityId}
              loadHeaderContent={(data) => loadHeaderContent(data)}
              onDownload={onDownload}
            />
            <div className="subletterhead">
              <table>
                <tr>
                  <td style={{ width: "70%" }}></td>
                  <td style={{ width: "30%" }}>
                    <p
                      className="date"
                      style={{
                        fontWeight: "bold",
                        float: "left",
                        textAlign: "left",
                        fontFamily:
                          letterCustomization?.styles?.fontFamily ||
                          "Times New Roman",
                        lineHeight: letterCustomization?.styles?.lineHeight,

                        lineSpacing: `${
                          letterCustomization?.styles?.lineSpacing || 0
                        }px`,
                      }}
                    >
                      {letterCustomization?.entity?.locationSector?.district
                        ?.name || ""}
                      , on {moment(new Date()).format("LL")}
                      {docLetterNo && (
                        <>
                          <br />N<sup>o</sup>:
                          <span style={{ fontWeight: "bold" }}>
                            {docLetterNo}
                          </span>
                        </>
                      )}
                    </p>
                  </td>
                </tr>
              </table>
            </div>
            <div className="recipient">
              <p
                style={{
                  fontWeight: "bold",
                  fontSize:
                    (letterCustomization?.styles?.fontSize || "12") + "px",
                  fontFamily:
                    letterCustomization?.styles?.fontFamily ||
                    "Times New Roman",
                  lineHeight: letterCustomization?.styles?.lineHeight,

                  lineSpacing: `${
                    letterCustomization?.styles?.lineSpacing || 0
                  }px`,
                }}
              >
                {recipientContent}
              </p>
            </div>
            <div className="content mb-2">
              <p
                style={{
                  fontWeight: "bold",
                  fontSize:
                    (letterCustomization?.styles?.fontSize || "12") + "px",
                  fontFamily:
                    letterCustomization?.styles?.fontFamily ||
                    "Times New Roman",
                  lineHeight: letterCustomization?.styles?.lineHeight,

                  lineSpacing: `${
                    letterCustomization?.styles?.lineSpacing || 0
                  }px`,

                  textAlign: titlePosition,
                }}
              >
                  {enableToFillLetter && titleInput ? (
                  titleInput
                ) : (
                  <>
                    {title}
                  </>
                )}
              </p>
              <br />
              <p
                style={{
                  fontSize:
                    (letterCustomization?.styles?.fontSize || "12") + "px",
                  fontFamily:
                    letterCustomization?.styles?.fontFamily ||
                    "Times New Roman",
                  lineHeight: letterCustomization?.styles?.lineHeight,

                  lineSpacing: `${
                    letterCustomization?.styles?.lineSpacing || 0
                  }px`,
                }}
              >
                {subTitle}
              </p>
              <p>
                {enableToFillLetter ? (
                  letterBodyContentInput
                ) : (
                  <>
                    <div
                      style={{
                        fontSize:
                          letterCustomization?.styles?.fontSize + "px" ||
                          "12px",
                        fontFamily:
                          letterCustomization?.styles?.fontFamily ||
                          "Times New Roman",
                        lineHeight: letterCustomization?.styles?.lineHeight,
                        textAlign:
                          letterCustomization?.styles?.textAlign || "justify",
                        lineSpacing: `${
                          letterCustomization?.styles?.lineSpacing || 0
                        }px`,
                      }}
                      dangerouslySetInnerHTML={{
                        __html: letterBodyContent,
                      }}
                    ></div>
                  </>
                )}{" "}
              </p>
            </div>
            {signContent && signContent}
            <div className="cc">
              {enableToFillLetter
                ? copiedInstitutionContentInput
                : !!copiedInstitutionContent && (
                    <>
                      <p
                        style={{
                          fontWeight: "bold",
                          fontSize:
                            (letterCustomization?.styles?.fontSize || "12") +
                            "px",
                          fontFamily:
                            letterCustomization?.styles?.fontFamily ||
                            "Times New Roman",
                          lineHeight: letterCustomization?.styles?.lineHeight,

                          lineSpacing: `${
                            letterCustomization?.styles?.lineSpacing || 0
                          }px`,
                        }}
                      >
                        Cc:
                      </p>
                      <div
                        style={{
                          fontSize:
                            (letterCustomization?.styles?.fontSize || "12") +
                            "px",
                          fontFamily:
                            letterCustomization?.styles?.fontFamily ||
                            "Times New Roman",
                          lineHeight: letterCustomization?.styles?.lineHeight,

                          lineSpacing: `${
                            letterCustomization?.styles?.lineSpacing || 0
                          }px`,
                        }}
                        dangerouslySetInnerHTML={{
                          __html: copiedInstitutionContent,
                        }}
                      ></div>
                    </>
                  )}{" "}
              {enableToFillLetter && (
                <>
                  <br /> {ccSelectForm}
                </>
              )}
            </div>
            <div className="mt-5 pt-5">
              <LetterTemplateFooter
                disableToEdit={disableToEditLetterHeader}
                loadFooterContent={loadFooterContent}
                planningEntityId={planningEntityId}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

const mapStateToProps = ({ planningEntities, selectedPlanningEntityId }) => {
  return { planningEntities, selectedPlanningEntityId };
};

export default connect(mapStateToProps, {
  selectPlanningEntity,
  getSelectedPlanningEntity,
  getEntitySectorPlanningEntities,
})(CustomizedLetter);
